import './../../resources_membership_hotel/css/hotel/membership_reserve_cancel.css'
import thanks_logo from '../../resources_membership_hotel/image/thanks_logo.gif';

export const ReserveInfoComf = (props) => {
    const { data } = props;
    return (
        <div className='membership_reserve_cancel_contentarea'>
            <div className='membership_reserve_cancel_title'>
                ご予約内容
            </div>
            <div className='membership_reserve_cancel_body'>
                <div className="reserveInfoContentBlock">
                    <div className='reservationContent lastContent'>
                        <div className='reserveInfoTitleGray block'>予約番号</div>
                        <div className='membership_reserve_cancel_info block'>{data.reservationNo}</div>
                    </div>
                </div>
                <div className="reserveInfoContentBlock">
                    <div className='reservationContent lastContent'>
                        <div className='reserveInfoTitleGray block'>ホテル名</div>
                        <div className='membership_reserve_cancel_info block'>{data.facilityName}</div>
                    </div>
                </div>
                <div className="reserveInfoContentBlock">
                    <div className='reservationContent lastContent'>
                        <div className='reserveInfoTitleGray'>チェックイン</div>
                        <div className='membership_reserve_cancel_info'>{data.checkin}</div>
                    </div>
                    <div className='reservationContent lastContent'>
                        <div className='reserveInfoTitleGray'>チェックアウト</div>
                        <div className='membership_reserve_cancel_info'>{data.checkout}</div>
                    </div>
                    <div className='reservationContent lastContent'>
                        <div className='reserveInfoTitleGray block'></div>
                        <div className='membership_reserve_cancel_info'>{data.hakusu}泊</div>
                    </div>
                </div>
                <div className="reserveInfoContentBlock">
                    <div className='reservationContent lastContent'>
                        <div className='reserveInfoTitleGray block'>室数</div>
                        <div className='membership_reserve_cancel_info block'>{data.roomNum}室</div>
                    </div>
                </div>
                <div className="reserveInfoContentBlock">
                    <div className='reservationContent lastContent'>
                        <div className='reserveInfoTitleGray block'>宿泊プラン名</div>
                        <div className='membership_reserve_cancel_info_block'>
                            <div>
                                {data.machiFlg == "1" ? "交換待ち" : data.machiFlg == "2" ? "キャンセル待ち" : data.machiFlg == "3" ? "交換キャンセル待ち" : data.planName}
                                <div>
                                    {data.adultDinnerRyokin ? "夕食" + data.adultDinnerRyokin.toLocaleString() + "円" : ""}
                                    {data.adultDinnerRyokin && data.breakfastTsukiPlanFlg ? "・" : ""}
                                    {data.breakfastTsukiPlanFlg ? "朝食付き" : ""}
                                </div>
                            </div>
                            <img
                                src={thanks_logo}
                                style={data.thanksFlg ? { height: "40px" } : { display: "none" }}
                            />
                        </div>
                    </div>
                </div>
                {data.ownerNo && (
                    <div className="reserveInfoContentBlock lastContent">
                        <div className='reservationContent lastContent'>
                            <div className='reserveInfoTitleGray block'>会員番号</div>
                            <div className='membership_reserve_cancel_info block'>{data.ownerNo}</div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};